'use client'

import Footer from '../_components/_ui/Footer'

const LegalLayout = ({ children }) => {
    return (
        <div className="min-h-screen w-full relative flex flex-col">
            <div className="relative z-10 flex-grow pt-20"> {/* Reduced padding since submenu is gone */}
                {/* Main Content */}
                {children}
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default LegalLayout 